import { isAuthExpiredError } from '@utils/isAuthExpiredError.js'

const ORG_ERROR_POLICY = { throwOnError: isAuthExpiredError }

export const useOrgErrorPolicy = () => ORG_ERROR_POLICY
